// extracted by mini-css-extract-plugin
module.exports = {"notification":"_3NTo-99X0qBz7wvqfqq_EF"};